import styled from 'styled-components';


export const SignUpContainer = styled.div`
width: 850px;
display: flex;
justify-content: space-between;
margin: 15px auto;
`;


export const RegistrationContainer = styled.div`
    width: 350px;
    display: flex;
    flex-direction: column;
    margin: 20px;
`;

export const TitleContainer = styled.h2`
    margin: 20px 0;
`;

export const InputTermsBox =styled.div`
padding-bottom: 10px;
`;

export const LogoContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 10px;

`;
